function getCutToken(token) {
    return token[0] + [token[1]] +"***" + token[token.length - 2] + token[token.length - 1]
}

export default getCutToken